import { FC } from "react";
import {
  TSrcSetMedia,
  IMAGE_SRCSET_MEDIA_MAP,
  TImageSrcSetProps,
  TSrcSetImage,
} from "./Image.config";

type TSrcSetEntry = [ TSrcSetMedia, TSrcSetImage ];

export const ImageSrcSet: FC<TImageSrcSetProps> = ({ images }) => (
  <>
    { images ? (Object.entries(images) as TSrcSetEntry[])
      .sort(([ a ], [ b ]) => IMAGE_SRCSET_MEDIA_MAP[b] - IMAGE_SRCSET_MEDIA_MAP[a])
      .map(
        ([ key, image ]) => (
          <source
            key={key}
            media={`(min-width:${IMAGE_SRCSET_MEDIA_MAP[key]}px)`}
            width={image.width}
            height={image.height}
            srcSet={image.src}
          />
        ),
      ) : null }
  </>
);
